<template>
  <div
    class="auth-popup__background"
    :class="{show: popupType !== null}">
    <div class="auth-popup__container">
      <div
        class="auth-popup__close"
        @click="closePopup">×
      </div>
      <div class="auth-popup__title">
        {{ title }}
      </div>
      <component :is="popupType"/>
      <div class="social-auth-title">Авторизуйтесь с помощью:</div>
      <div class="social-auth-row">
        <div class="social-auth-item">
          <!--a href="/authredirect.php?social=vk"-->
          <a href="javascript:void(0)" onclick="" data-social="VKontakte">
            <img src="/local/images/social_auth/vk.svg" alt="">
          </a>
        </div>
        <div class="social-auth-item">
          <!--a href="/authredirect.php?social=yandex"-->
          <a href="javascript:void(0)" onclick="" data-social="YandexOAuth">
            <img src="/local/images/social_auth/yandex.svg" alt="">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'
  import Authorize from '../Authorize/AuthForm'
  import PhoneInput from './PhoneInputPopup'
  import PhoneCheck from './PhoneCheckPopup'
  import Register from '../Register/RegForm'

  export default {
    name: 'Popup',
    components: {
      Authorize,
      PhoneInput,
      PhoneCheck,
      Register
    },
    data: function () {
      return {
        title: ''
      }
    },
    mounted: function () {
      window.openPopupAuthorize = () => this.setPopupType('authorize')
      window.openPopupInputPhone = () => this.setPopupType('phoneInput')
      window.$('.open-auth-popup').on('click', () => {
        this.setIsPopup(true)
        window.openPopupAuthorize()
      })

      window.$('.head_lk_a').on('click', () => {
        this.setIsPopup(true)
        window.openPopupAuthorize()
      })
    },
    computed: {
      ...mapGetters('auth', [
        'getPopupType'
      ]),
      popupType: function () {
        switch (this.getPopupType) {
          case 'authorize':
            this.title = 'ВХОД В ЛИЧНЫЙ КАБИНЕТ'
            return 'Authorize'
          case 'phoneInput':
            this.title = 'ВХОД'
            return 'PhoneInput'
          case 'phoneCheck':
            this.title = 'ВХОД'
            return 'PhoneCheck'
          case 'register':
            this.title = 'РЕГИСТРАЦИЯ'
            return 'Register'
          default:
            return null
        }
      }
    },
    methods: {
      ...mapMutations('auth', [
        'setPopupType',
        'setIsPopup'
      ]),
      closePopup: function () {
        this.setIsPopup(false)
        this.setPopupType(null)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Auth/Popups/Popup.vue